import { cn } from '@plato/ui/util/classes';
import type React from 'react';
import type { MutableRefObject } from 'react';
import { forwardRef } from 'react';

type CommonProps = {
    text?: string;
} & React.PropsWithChildren;

type ButtonProps = { as: 'button' } & Omit<React.ComponentPropsWithoutRef<'button'>, 'children'>;
type AnchorProps = { as?: 'a' } & Omit<React.ComponentPropsWithoutRef<'a'>, 'children'>;

type Props = CommonProps & (ButtonProps | AnchorProps);

export const LinkText = forwardRef<HTMLElement, Props>((props, ref) => {
    const styleClasses =
        'cursor-pointer select-none text-sm font-medium text-blue-500 hover:text-blue-600 hover:underline';

    if (props.as === 'button') {
        const { as, children, className, text, ...rest } = props;
        return (
            <button
                className={cn(styleClasses, className)}
                ref={ref as MutableRefObject<HTMLButtonElement>}
                type="button"
                {...rest}
            >
                {text || children}
            </button>
        );
    }

    const { as, children, className, text, ...rest } = props;
    return (
        <a className={cn(styleClasses, className)} ref={ref as MutableRefObject<HTMLAnchorElement>} {...rest}>
            {text || children}
        </a>
    );
});

LinkText.displayName = 'LinkText';
